import React, { useEffect } from 'react'
import Loaders from '../../../components/loaders/Loaders'
import { FaClock, FaFile, FaFolder, FaSlash, FaVideo } from 'react-icons/fa'
import { truncateString } from '../../../helpers/helpers'
import { deleteStudentVideoSubscription, deleteStudentVideoSubscriptionById, getAdminStudentVideoNSubModulesDir, getAllVideoFromModules } from '../../../service/admin/adminVideoes.service'
import moment from 'moment'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

export default function AdminStudentVideoDetails(props:{data:any,loading:boolean,studentId:string,subscriptionId:string}) {
    const [fetchData, setFetchData] = React.useState<any>([])
    const [videoList, setVideoList] = React.useState<any>([])
    const [videoLoading, setVideoLoading] = React.useState(false)
    const [deleteItem, setDeleteItem] = React.useState<any>([])
    const [showVisible, setShowVisible] = React.useState("true")
    const [breadCrum, setBreadCrum] = React.useState<any>([{
        name:'Root',
        mod:"",
        sub:"",
        types:"dir"
    }])
    const [loading, setLoading] = React.useState(false)
    
    const fetchNsubModules = async (moduleId:string,subModuleId:string,name:string,dir:string) => {
      console.log(dir)
      setBreadCrum((prev: any) => {
        const newItem = { name, mod: subModuleId, sub: moduleId, types: dir };
        const keyToCheck = `${newItem.mod}-${newItem.sub}`;
      
        // Find index of existing dir with same mod-sub
        const existingIndex = prev.findIndex(
          (item: any) =>
            item.types === 'dir' && `${item.mod}-${item.sub}` === keyToCheck
        );
      
        if (existingIndex !== -1) {
          // If found, remove that and all after it
          return [
            ...prev.slice(0, existingIndex),
            newItem // Add fresh version
          ];
        }
      
        // Else, add normally
        return [...prev, newItem];
      });
            setShowVisible("true")
            setVideoList([])
            
            let get:any = await getAdminStudentVideoNSubModulesDir(props.studentId,moduleId,props.subscriptionId,subModuleId)
            if(get?.status === "success"){
                setFetchData(get?.message)
            }
    }
    const fetchVideoList = async (moduleId:string,subModuleId:string,name:string) => {
      setShowVisible("false")
      setBreadCrum((prev:any)=>[
          ...prev,
          { name: name, mod: subModuleId, sub: moduleId,types:"vid"}
      ])
      console.log(moduleId,subModuleId)
      let get:any = await getAllVideoFromModules(subModuleId,moduleId)
      if(get?.status === "success"){
          setVideoList(get?.message)
      }
}
    useEffect(()=>{
      setFetchData(props.data)
    },[props.data])
   const handleRoot = async()=>{
    setBreadCrum([{
        name:'Root',
        mod:"",
        sub:"",
    }])
    setShowVisible("true")
    setVideoList([])
    setFetchData(props.data)
   }
   console.log(breadCrum)
   const deleteAccess= async(data:any)=>{
    setLoading(true)
    
    if(data.length > 0){
      let get:any = await deleteStudentVideoSubscription(data)
      if(get?.status === "success"){
          setLoading(false)
          setFetchData(fetchData.filter((item:any) => !data.includes(item.id)))
          toast.success(get?.message)

     }
    }else{
      toast.error("Please select atleast one item")
    }
  }

  const handleDeleteAccess = async(id:string)=>{
    
    Swal.fire({
      title: "Do you want to remove access from this student?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No`
    }).then(async(result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        
        await deleteAccess([id])
      } 
    });

   
  }
  const deleteSubModuleById = async(id:any)=>{
    Swal.fire({
      title: "Do you want to remove access from this student?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No`
    }).then(async(result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        let del:any = await deleteStudentVideoSubscriptionById(id);
        if(del?.status === "success"){
          Swal.fire("Removed!", "", "success");
          window.location.reload()
        }
      } 
    });
  }
  return (
    
        <>
        <div className='flex gap-1 justify-start items-center  px-3 py-1 rounded-xl mb-3'>
        {
            breadCrum.length > 0 &&
                breadCrum.map((e:any,index:number)=>(
                    index === 0 ? 
                    <>
                    
                    <button onClick={(()=>handleRoot())} className={`text-md  ${index+1 === breadCrum.length ? "text-gray-900" : "text-gray-500"}`}>{e?.name}</button>
                    </>
                    :
                    index+1 == breadCrum.length ?
                    <>
                     / <button className={`text-md  ${index+1 === breadCrum.length ? "text-gray-900" : "text-gray-500"}`}>{e?.name}</button>
                    </>
                    :
                    <>
                    /
                    <button onClick={(()=>e.types === "dir" ? fetchNsubModules(e.sub,e.mod,e.name,e.types) :fetchVideoList(e.mod,e.sub,e.name) )}className={`text-md  ${index+1 === breadCrum.length ? "text-gray-900" : "text-gray-500"}`}>{e?.name}</button>
                    
                    </>
                ))

        }
        </div>
        {
            loading ?
            <Loaders type='spinner' />
            :
            showVisible === "true" &&
            <div>
              {
                 fetchData.length > 0 ?
                 <div className=''>
                  
                   {
                     fetchData.map((e:any, index:number) =>(
                       <div
                                                            key={index}
                                                            className=" "
                                                          >
                                                           {
                                                            e.videoSubModule.types === "dir" ? 
                                                            <div className="flex flex-col p-2 border border-gray-300 rounded-lg bg-gray-100">
                                                            <div onClick={(()=>fetchNsubModules(e?.videoSubModule?.id,e?.videoSubModule.videoModule?.id,e?.videoSubModule?.name,e.videoSubModule.types))} className='flex justify-start items-center px-2 py-4 gap-3 hover:cursor-pointer'>
                                                            <FaFolder className='text-yellow-500 text-5xl' />
                                                            <p data-tooltip={e?.videoSubModule?.name} className="ml-2  text-lg">{truncateString(e?.videoSubModule?.name,20)}</p>
                                                            </div>
                                                            <button onClick={(()=>handleDeleteAccess(e.id))}  className='bg-red-400 text-white p-1 font-semibold rounded-md hover:shadow-xl'>Remove Access</button>
                                                          </div>
                                                          :
                                                          <div className="flex flex-col p-2 border border-gray-300 rounded-lg bg-gray-100">
                                                          <div onClick={(()=>fetchVideoList(e?.videoSubModule?.id,e?.videoSubModule.videoModule?.id,e?.videoSubModule?.name))} className='flex justify-start items-center px-2 py-4 gap-3 hover:cursor-pointer'>
                                                          <FaFile className='text-blue-500 text-5xl' />
                                                          <p data-tooltip={e?.videoSubModule?.name} className="ml-2  text-lg">{truncateString(e?.videoSubModule?.name,20)}</p>
                                                          </div>
                                                          <button onClick={(()=>deleteSubModuleById(e?.id))} className='bg-red-400 text-white p-1 font-semibold rounded-md hover:shadow-xl'>Remove Access</button>
                                                        </div>
                                                           }
                                                          </div>
                  ))
                   }
                 </div>
                 :
                 showVisible == "true" &&
                 <p className='p-4 text-lg w-full text-center'>No Data found</p>
              }
            </div>
            
            
        }
        <div>
          {
            showVisible == "false" &&
            videoLoading ? 
            <Loaders type='spinner' />
            :
            <div className='grid grid-cols-2  gap-4'>
              {
                videoList.length > 0 ?
                videoList.map((item:any,index:number)=>(
                  <div key={index} className='  flex justify-start flex-col my-2 items-center gap-3 p-2 border border-gray-300 rounded-lg bg-gray-100'>
                    <img src={`${item.thumbnail}`} className='w-full h-[250px]' />
                    <div className='flex justify-between items-center w-full flex-wrap'>
                      <p data-tooltip={item.name} className='text-lg ml-2'>{truncateString(item.name,20)}</p>
                      <p className='text-lg flex gap-1 items-center'> <FaClock/> { moment.utc(moment.duration(item.length, 'seconds').asMilliseconds()).format('HH:mm:ss')}</p>
                    </div>
                  </div>
                ))
                :
                showVisible == "false" &&
                <p className='p-4 text-lg w-full text-center'>No video found</p>
              }
            </div>
          }
        </div>
        </>
    
  )
}
